import DocumentActivity from "./documentActivity";

class VideoActivity extends DocumentActivity {
	constructor(config = {}) {
		super(config);
		this.interactiveQuestions = this.initInteractiveQuestions(
			config.interactiveQuestions || []
		);
		//answers if previously submitted
		let restrictedViewConfigObj = {};

		this.activityMetaInformation = config.activityMetaInformation
			? JSON.parse(config.activityMetaInformation)
			: restrictedViewConfigObj;
		this.userAnsweredQuestionIds = config.userAnsweredQuestionIds || [];
		this.allowedViewCount = config.allowedViewCount || 0;
	}

	initInteractiveQuestions = interactiveQuestions => {
		var toReturn = [];
		interactiveQuestions.forEach(function(questionData) {
			var videoInteractiveQuestion = this.deserializeFromSavedData(
				questionData
			);
			toReturn.push(videoInteractiveQuestion);
		}, this);
		return toReturn;
	};

	toAllowLimitedViewsConfiguration() {
		return this.activityMetaInformation.allowedViewCount != undefined;
	}

	deserializeFromSavedData = data => {
		var questionData = {...JSON.parse(data.questionObject)}; //
		questionData.questionId = data.questionId;
		return questionData;
	};
	hasExceededViewingLimit(viewedCount) {
		return (
			this.allowedViewCount > 0 &&
			viewedCount >= this.activityMetaInformation.allowedViewCount
		);
	}

	getInteractiveQuestionLocations() {
		return this.interactiveQuestions.map(function(quizQuestion) {
			return quizQuestion.timeToProjectQuestion / 1000;
		});
	}
}

export default VideoActivity;

/*TODO: Extend this class from Activity instead of DocumentActivity*/



// WEBPACK FOOTER //
// ./src/videoActivity.js